import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { formatNumber } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	label: string;
	amount: number;
};

export const RemainingRow: FC<Props> = ({ label, amount }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			gap={theme.spacingTokens.sm}
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
			bgcolor={theme.palette.surface.muted}
			borderTop={1}
			borderColor="surface.border"
		>
			<Typography variant="bodyMedium" color={theme.palette.grey[700]}>
				{label}
			</Typography>
			<Typography variant="bodyStrong" tabular>
				{formatNumber(amount)} {t(Resources.Goals.Amount.currencySign)}
			</Typography>
		</Stack>
	);
};
